window.addEventListener("load", function(){
    let upsellTriggers = document.querySelectorAll(".checkbox-upsell input[type=checkbox]");
    let upsellApplied = false;

    // Call this after EVERY time updateSummary() renders the total
    function syncUpsellToTotal() {
        upsellTriggers.forEach(function(upsellTrigger){
            if (upsellTrigger && upsellTrigger.checked) {
                let upsellPriceCents = upsellTrigger.getAttribute("price");
                let upsellDiscCents = upsellTrigger.getAttribute("discount");

                let qty = Number(upsellTrigger.getAttribute("qty"));
                adjustSummaryTotal(Number(Number(upsellPriceCents) * qty), Number(upsellDiscCents * qty));
                upsellApplied = true;
            }
        });
    }
    syncUpsellToTotal(); 

    // Listen for summary re-renders
    document.addEventListener('smileSummaryUpdated', function () {
        syncUpsellToTotal();
    });

    upsellTriggers.forEach(function(upsellTrigger){
        upsellTrigger.addEventListener("input", function(){
            console.log("..");
            let qty = Number(upsellTrigger.getAttribute("qty"));
            let upsellPriceCents = upsellTrigger.getAttribute("price") * qty;
            let upsellDiscCents = upsellTrigger.getAttribute("discount") * qty;

            if (upsellTrigger.checked) {
                addToCart(upsellTrigger.getAttribute("id"), Number(qty), null);
                adjustSummaryTotal(upsellPriceCents, upsellDiscCents);
                upsellApplied = true;
            } else if (!upsellTrigger.checked ) {
                removeFromCartByVariantId(upsellTrigger.getAttribute("id"));
                adjustSummaryTotal(-upsellPriceCents, -upsellDiscCents);
                upsellApplied = false;
            }
        });
    })  

    function adjustSummaryTotal(deltaCents, deltaDiscCents) {
        deltaCents = Number(deltaCents);
        var totalEl = document.querySelector('[data-summary-total]');
        var totalDiscEl = document.querySelector('[data-summary-discount]');

        if (!totalEl) return;

        var currentText = totalEl.textContent.replace(/[^0-9.]/g, '');
        var currentCents = Math.round(parseFloat(currentText) * 100);
        var newCents = currentCents + deltaCents;

        var currentDiscText = totalDiscEl.textContent.replace(/[^0-9.]/g, '');
        var currentDiscCents = Math.round(parseFloat(currentDiscText) * 100);
        var newDiscCents = currentDiscCents + deltaDiscCents;

        console.log({currentCents, deltaCents, newCents, newDiscCents, deltaDiscCents})

        totalEl.textContent = '$ ' + (newCents / 100).toFixed(2);
        totalDiscEl.textContent = '$ ' + (newDiscCents / 100).toFixed(2);

    }
    // Function to add a product to the cart
    function addToCart(variantId, quantity = 1, e = null) {
        if (!variantId) {
        console.error("Variant ID is required.");
        return;
        }

        const button = e?.target;
        if (button) {
        console.log(button)
        button.setAttribute("status", "adding");
        button.disabled = true;
        }

        // Setup formData like Shopify product-form.js
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', quantity);
        // formData.append('sections', ['cart-drawer', 'cart-icon-bubble']);
        // formData.append('sections_url', window.location.pathname); 

        console.log({formData})

        const config = {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData
        };

        fetch('/cart/add.js', config)
        .then(res => res.json())
        .then(data => {
            // Shopify-style: Handle error from backend
            if (data.status && data.message) {
            console.error("ADD TO CART error:", data.message);
            if (button) {
                // button.textContent = "Error";
                // button.setAttribute("status", "error");
            }
            return;
            }else{
                // button.setAttribute("status", "added");
            }
            document.dispatchEvent(
            new CustomEvent('cart-has-updates', {
                bubbles: true,
                detail: {
                cartUpdated: true,
                source: 'custom-add-to-cart'
                }
            })
            );

        })
        .catch((err) => {
            console.error("Cart Add Error:", err);
            if (button) button.classList.add("error");
            button.setAttribute("status", "error");
            setTimeout(function(){
            button.classList.remove("error")
            }, 1000)
        })
        .finally(() => {
            if (button) {
            setTimeout(() => {
                // button.textContent = "ADD TO CART";
                button.setAttribute("status", "atc-cta");
                button.disabled = false;
            }, 1500);
            }

            document.dispatchEvent(new CustomEvent('cart:refresh'));

            if (typeof CartPerformance !== 'undefined' && e) {
            CartPerformance.measureFromEvent("add:user-action", e);
            }
        });
    }
    function removeFromCartByVariantId(variantId) {
        fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            updates: {
            [variantId]: 0
            }
        })
        })
        .then(response => response.json())
        .then(data => {
        console.log('Item removed successfully');
        // Optional: reload cart UI
        // location.reload(); 
        })
        .catch(error => {
        console.error('Error removing item:', error);
        });
        document.dispatchEvent(
            new CustomEvent('cart-has-updates', {
            bubbles: true,
            detail: {
                cartUpdated: true,
                source: 'custom-add-to-cart'
            }
            })
        );
    }

})